import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { saveDraftForReturn } from "../store/commonSlices/lookupsSlice";

export const useAddNewNavigation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const goToAddNew = (path, returnTarget, currentFormValues) => {
    dispatch(saveDraftForReturn({ data: currentFormValues, returnTarget }));
    navigate(`${path}?from=${returnTarget}`);
  };

  return goToAddNew;
};
